// dependencies
import { useQuery } from "@tanstack/react-query";

import { type GetGroupsParams, getGroups, getGroupsInternalApi } from "../../services";

// api services

/** @deprecated Use `useGroupsInternalApi` instead. */
export const useGroups = () => {
	return useQuery({
		queryKey: ["groups"],
		queryFn: async () => {
			const results = await getGroups();

			if (results?.errors?.length > 0) {
				throw new Error(results.errors.join(", "));
			}

			return results?.groups;
		},
		meta: {
			errorMessage: "There was an error getting the groups.",
		},
	});
};

export const useGroupsInternalApi = (params?: GetGroupsParams) => {
	return useQuery({
		queryKey: ["groups", "internal-api", params],
		queryFn: () => getGroupsInternalApi(params),
		meta: {
			errorMessage: "There was an error getting the groups.",
		},
	});
};
